
import { Validation } from 'bunnyjs/src/Validation';
import XHR from '../../utils/xhr';

function serialize(form) {
    var field, l, s = [];
    if (typeof form == 'object' && form.nodeName == "FORM") {
        var len = form.elements.length;
        for (var i=0; i<len; i++) {
            field = form.elements[i];
            if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
                if (field.type == 'select-multiple') {
                    l = form.elements[i].options.length;
                    for (var j=0; j<l; j++) {
                        if(field.options[j].selected)
                            s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
                    }
                } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                    s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
                }
            }
        }
    }
    return s.join('&').replace(/%20/g, '+');
}

export default class ContactForm {
	constructor() {

		this.el = {
			section: document.querySelector('.contact-form'),
			form: document.querySelector('.contact-form form'),
			submitButton: document.querySelector('.contact-form [type="submit"]'),
			successMessge: document.querySelector('.contact-form .contact-form__success')
		};

		if (!this.el.section) {
			return;
		}

		this.xhr = new XHR('json');

		this._addListeners();
	}

	_addListeners() {
		this._onSubmit = this._onSubmit.bind(this);
		this.el.form.addEventListener('submit', this._onSubmit);
		this.el.submitButton.addEventListener('click', this._onSubmit);

		Validation.init(this.el.form, true);
	}

	_onSubmit(e) {

		e.preventDefault();

		this.el.submitButton.disabled = true;

		Validation.validateSection(this.el.form).then(result => {
			if (result === true && window.FormData) {
				const url = this.el.form.action.value + '.json';
				const data = serialize(this.el.form);

				this.xhr.post(url, data)
					.then((res) => {
						if (res.status === 200) {
							this.el.successMessge.classList.add('is-visible');
							this.el.form.classList.add('is-hidden');
						} else {
							console.error('There was an error submitting the request', res);
						}
					});
			} else {
				this.el.submitButton.disabled = false;
				// section invalid, result is array of invalid inputs
				Validation.focusInput(result[0]);
			}
		});

		return false;
	}
}
